import {combineReducers} from 'redux';
import reduceReducers from 'reduce-reducers';
import { reducer as formReducer } from 'redux-form';
import { routerReducer } from 'react-router-redux';
import { loadingBarReducer } from 'react-redux-loading-bar';

import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,

    ACTION_REQUEST,
    ACTION_SUCCESS,
    ACTION_FAILURE

} from '../constants/login';

import { Urls } from 'django_js_control/reverse';

const INITIAL_STATE = {
    request: false,
    email: undefined,
    status: undefined
};

const login = function (state = INITIAL_STATE, action = undefined) {

    const { type } = action;

    switch (type) {

    case LOGIN_REQUEST:
    case ACTION_REQUEST:

        return { ...state, request: true };

    case LOGIN_SUCCESS:
    case ACTION_SUCCESS:

        if (action.data.status === 'success') {
            window.location = action.meta.next || Urls['control:index']();
        }

        return { ...state, request: false, status: action.data.status, email: action.meta.email || state.email };

    case LOGIN_FAILURE:
    case ACTION_FAILURE:

        return { ...state, request: false };


    default:

        return state;
    }
};

const loginCombo = reduceReducers(combineReducers({
    login,
    loadingBar: loadingBarReducer,
    form: formReducer,
    router: routerReducer
}));

export default loginCombo;



// WEBPACK FOOTER //
// ./assets/app/login/reducers/login.js